<header #header [enableImpersonation]="true" brandImage="../../assets/common/header/logo-randstad.png"
  brandImageAlt="Randstad">
  <div userActions style="display: flex; flex-direction: row; flex-wrap: nowrap; justify-content: flex-end;">
    <help [compactView]="false"></help>
  </div>
</header>
<div class="container-fluid rs-container">
  <div class="row">
    <loading-overlay [show]="loading" style="width: 100%;">
      <div class="col-12 col-md-12 col-lg-12 col-xl-12 bd-content" style="max-width: 100%;">
        <app-vacancies-table [columnDefinitions]="columnDefinitions" [tabledata]="tabledata"></app-vacancies-table>
      </div>
    </loading-overlay>
  </div>
</div>

